// extracted by mini-css-extract-plugin
export default {"cls1":"_yvE6PZwqK9uctYTT9oW","cls2":"iYRubdyUIHbJ4qSIEox1 _yvE6PZwqK9uctYTT9oW","isTablet":"QSB4iM_ndyoTFybPbHQL","isLargeScreen":"vvIFzENufWklqf_GLcaq"};